import { useEffect, useRef } from 'react';
import OverlayScrollbars from 'overlayscrollbars';
import { OverlayScrollbarsComponent } from 'overlayscrollbars-react';

export const ScrollBar = (props) => {
	const osTargetRef = useRef(null);

	useEffect(() => {
		let osInstance = null;
		osInstance = OverlayScrollbars(
			osTargetRef.current,
			props.options || {},
			props.extensions
		);
		return () => {
			if (osInstance && osInstance.destroy) osInstance.destroy();
		};
	}, [props]);

	return (
		<OverlayScrollbarsComponent {...props} ref={osTargetRef}>
			{props.children}
		</OverlayScrollbarsComponent>
	);
}
